import { clientPortalApi } from '@/lib/api/client-portal.api'
import { useQuery } from '@tanstack/react-query'

/**
 * The portal summary (entity, branding, effective settings, internal-viewer
 * flag). One key for every surface, so the layout, the top-bar Benny pill,
 * the desktop title bar and the Benny page share a single fetch.
 */
export function useClientPortalSummary(entityId: string | undefined) {
  return useQuery({
    queryKey: ['client-portal', entityId, 'summary'],
    queryFn: () => clientPortalApi.getPortalSummary(entityId!),
    enabled: !!entityId,
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
  })
}
